import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import { CancelIcon } from 'images'
import { FdSelect } from 'components/Shared/ReactSelect'
import { PlacementPlatform } from 'domain/adPreview/placementGroups'

const LABEL_KEYS_BY_PLATFORM = {
  all: 'Recommendations.adPreview.filters.all',
  [PlacementPlatform.META]: 'Recommendations.adPreview.filters.meta',
  [PlacementPlatform.GOOGLE]: 'Recommendations.adPreview.filters.google',
}

// Platform filter pills — one per active platform plus "All" when there's
// more than one platform to filter between.
export function getFilterOptions(activePlatforms) {
  const platforms = Array.isArray(activePlatforms) ? activePlatforms : []
  const pills = platforms.map((platform) => ({
    value: platform,
    labelKey: LABEL_KEYS_BY_PLATFORM[platform],
  }))
  if (platforms.length > 1) {
    return [{ value: 'all', labelKey: LABEL_KEYS_BY_PLATFORM.all }, ...pills]
  }
  return pills
}

const Header = ({
  tasteClusterOptions,
  selectedTc,
  onTcChange,
  activePlatforms,
  platformFilter,
  onPlatformFilterChange,
  onClose,
}) => {
  const { t } = useTranslation()
  const filterOptions = getFilterOptions(activePlatforms)

  return (
    <div className="preview-ads-modal__header">
      <div className="preview-ads-modal__header-title">
        <h3 className="preview-ads-modal__title">{t('Recommendations.adPreview.title')}</h3>
        <FdSelect
          className="preview-ads-modal__tc-select"
          options={tasteClusterOptions}
          value={tasteClusterOptions.find((option) => option.value === selectedTc) ?? null}
          onChange={(option) => onTcChange(option.value)}
          isSearchable={false}
        />
        <div className="preview-ads-modal__filters">
          {filterOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              className={cn('preview-ads-modal__filter-pill', {
                'preview-ads-modal__filter-pill--active': platformFilter === option.value,
              })}
              onClick={() => onPlatformFilterChange(option.value)}
            >
              {t(option.labelKey)}
            </button>
          ))}
        </div>
      </div>
      <button type="button" className="preview-ads-modal__close" onClick={onClose}>
        <CancelIcon width={16} />
      </button>
    </div>
  )
}

Header.propTypes = {
  tasteClusterOptions: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }),
  ).isRequired,
  selectedTc: PropTypes.string,
  onTcChange: PropTypes.func.isRequired,
  activePlatforms: PropTypes.arrayOf(PropTypes.string),
  platformFilter: PropTypes.string.isRequired,
  onPlatformFilterChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
}

export default Header
